<app-admin-toast></app-admin-toast>
<div class="padding-component">
    <app-header [title]="'Recursos'"></app-header>
    <mat-tab-group>
        <mat-tab label="Empleados"><app-employee-list></app-employee-list></mat-tab>
        <!-- <mat-tab label="Asistencia"><app-attendance-list></app-attendance-list></mat-tab> -->
        <mat-tab label="Vehiculos"><app-vehicles></app-vehicles></mat-tab>
    </mat-tab-group>
</div>